import { Tag } from "features/shared/types/tag";
import { TagAction, TagActionTypes } from "../types/actions";

const initialState: Array<Tag> = [];

const listsReducer = (
    state = initialState,
    action: TagActionTypes
): Array<Tag> => {
    switch (action.type) {
        case TagAction.SET_TAGS:
            return action.tags;
        default:
            return state;
    }
};

export default listsReducer;
